import * as Sentry from '@sentry/react';
import pkg from '../../package.json';
import { Env } from '../Env';
// Rate limiting configuration per route pattern
const rateLimits = {
    '/stream': { maxErrors: 20, timeWindow: 60000 }, // 20 errors per minute for all stream pages
    '/embed': { maxErrors: 20, timeWindow: 60000 }, // 20 errors per minute for all embed pages
    '*': { maxErrors: 30, timeWindow: 60000 }, // 30 errors per minute for all other routes
};
const errorTimestamps = {};
// Helper function to get route pattern from hash path
const getRoutePattern = (hash) => {
    const cleanPath = hash.replace(/^#/, '');
    // Match against known route patterns
    if (cleanPath.startsWith('/stream/'))
        return '/stream';
    if (cleanPath.startsWith('/embed/'))
        return '/embed';
    return '*'; // Return wildcard pattern for unmatched routes
};
export const initSentry = () => {
    Sentry.init({
        dsn: Env.SENTRY_DSN,
        enabled: Env.isProduction(),
        release: pkg.version,
        environment: Env.NODE_ENV,
        beforeSend: (event) => {
            const eventToSend = removeSensitiveData(event);
            // Disable throttling for now as there are measures on Sentry side to prevent getting overwhelmed
            // return checkThrottle(event);
            return eventToSend;
        },
    });
};
const removeSensitiveData = (event) => {
    if (event.request != null && event.request.url != null) {
        const cleanedUrl = new URL(event.request.url);
        // Remove hash so that we don't expose secrets like stream id and encryption key
        cleanedUrl.hash = '';
        event.request.url = cleanedUrl.toString();
    }
    return event;
};
// biome-ignore lint/correctness/noUnusedVariables: Disabled for now
const checkThrottle = (event) => {
    const hash = window.location.hash;
    const routePattern = getRoutePattern(hash);
    // Initialize timestamps array for this route pattern if not exists
    if (!errorTimestamps[routePattern]) {
        errorTimestamps[routePattern] = [];
    }
    // Get rate limit config for this route pattern
    const limit = rateLimits[routePattern];
    // Clean up old timestamps
    const now = Date.now();
    errorTimestamps[routePattern] = errorTimestamps[routePattern].filter((timestamp) => now - timestamp < limit.timeWindow);
    // Check if we've exceeded the rate limit
    if (errorTimestamps[routePattern].length >= limit.maxErrors) {
        return null; // Drop the event
    }
    // Add new timestamp
    errorTimestamps[routePattern].push(now);
    return event;
};
